import React, {Component} from "react";
import axios from "axios";
import {Link} from "react-router-dom";
import ReservationForm from "../../components/ReservationForm/ReservationForm";
import ReservationEditButtons from "../../components/ReservationEditButtons/ReservationEditButtons";
import Recommends from "../../components/RecommendedRooms/Recommends";

class MyReservations extends Component {

    state = {
        userDetails: JSON.parse(localStorage.getItem("user")),
        myReservations: [],
        recommendations: [],
        reservationFormData: {
            reservationId: {
                value: 0,
                isValid: true,
                message: ''
            },
            guestName: {
                value: '',
                isValid: true,
                message: ''
            },
            startDate: {
                value: '',
                isValid: true,
                message: ''
            },
            endDate: {
                value: '',
                isValid: true,
                message: ''
            },
            roomId: {
                value: -1,
                isValid: true,
                message: ''
            }
        }
    };

    componentDidMount() {
        this.getReservations();
        this.getRecommendations();
    }

    getReservations = () => {
        axios.get("/api/users/" + this.state.userDetails.id + "/my-reservations")
            .then(response => {
                this.setState({
                    myReservations: response.data
                })
            })
            .catch(error => {
                console.log(error);
            });
    };

    getRecommendations = () => {
        axios.get("/api/users/" + this.state.userDetails.id + "/recommends")
            .then(response => {
                this.setState({
                    recommendations: response.data
                })
            })
            .catch(error => {
                console.log(error);
            });
    };


    inputChangeHandler = (event) => {
        const updatedReservationForm = {...this.state.reservationFormData};
        const updatedFormElement = {...updatedReservationForm[event.target.name]};
        updatedFormElement.value = event.target.value;
        updatedFormElement.isValid = 'true';
        updatedReservationForm[event.target.name] = updatedFormElement;
        this.setState({reservationFormData: updatedReservationForm});
    };

    reservationSubmit = (event) => {
        event.preventDefault();
        let formData = {};
        for (let formElementId in this.state.reservationFormData) {
            if (this.state.reservationFormData.hasOwnProperty(formElementId)) {
                formData[formElementId] = this.state.reservationFormData[formElementId].value;
            }
        }

        formData = {
            ...formData,
            userId: this.state.userDetails.id
        };

        console.log("Logging userDetails from state:", this.state.userDetails.id);
        console.log("Logging form data with user id:", formData);

        let url = '/api/rooms/' + this.state.userDetails.id + '/reservations';
        let method = 'post';
        if (this.state.reservationFormData.reservationId.value) {
            url += '/' + this.state.reservationFormData.reservationId.value;
            method = 'put';
        }

        const user = JSON.parse(localStorage.getItem('user'));
        if (user.role !== "ROLE_ADMINISTRATOR" ||
            (user.role === "ROLE_ADMINISTRATOR" && method === "put")) {
            axios({method: method, url: url, data: formData})
                .then(() => {
                    this.getReservations();
                }).catch(error => {
                console.warn('RoomDetails reservationSubmit error:', error);
                console.warn('RoomDetails reservationSubmit error.response:', error.response);
                this.validationHandler(error.response.data);
            });
        }

    };

    deleteReservationHandler = (id) => {
        console.log("deleteReservationHandler: ", "/api/rooms/" + this.props.match.params.id + "/reservations/" + id)
        axios.delete("/api/rooms/" + this.props.match.params.id + "/reservations/" + id)
            .then(response => {
                console.log(response);
                this.componentDidMount();
            })
            .catch(error => {
                console.warn(error.response);
            });
    };

    reservationEdit = (id, guestName, startDate, endDate, roomId) => {
        const monthDayFormat = (number) => {
            return number > 9 ? "" + number : "0" + number;
        };
        const startDateRightFormat = startDate[0] + "-" + monthDayFormat(startDate[1]) + "-" + monthDayFormat(startDate[2]);
        const endDateRightFormat = endDate[0] + "-" + monthDayFormat(endDate[1]) + "-" + monthDayFormat(endDate[2]);


        this.setState({
            reservationFormData: {
                reservationId: {
                    value: id,
                    isValid: true,
                    message: ''
                },
                guestName: {
                    value: guestName,
                    isValid: true,
                    message: ''
                },
                startDate: {
                    value: startDateRightFormat,
                    isValid: true,
                    message: ''
                },
                endDate: {
                    value: endDateRightFormat,
                    isValid: true,
                    message: ''
                },
                roomId: {
                    value: roomId,
                    isValid: true,
                    message: ''
                }
            }
        });

    };

    validationHandler = (error) => {
        const updatedReservationForm = {...this.state.reservationFormData};

        for (let field in this.state.reservationFormData) {
            const updatedFormElement = {
                ...updatedReservationForm[field]
            };
            updatedFormElement.isValid = true;
            updatedFormElement.message = '';
            updatedReservationForm[field] = updatedFormElement;
        }

        for (let fieldError of error.fieldErrors) {
            const updatedFormElement = {
                ...updatedReservationForm[fieldError.field]
            };
            updatedFormElement.isValid = false;
            updatedFormElement.message = fieldError.message;
            updatedReservationForm[fieldError.field] = updatedFormElement;
        }
        this.setState({reservationFormData: updatedReservationForm});
    };




    buttons = (reservation) => {
        return (
            <ReservationEditButtons
                id={reservation.id}
                guestName={reservation.guestName}
                startDate={reservation.startDate}
                endDate={reservation.endDate}
                roomId={reservation.roomId}
                reservationEdit={this.reservationEdit}
                deleteHandler={this.deleteReservationHandler}
                userName={reservation.guestName}
            />
        );
    };

    reservedDate = (startDate, endDate) => {
        const monthDayFormat = (number) => {
            return number > 9 ? "" + number : "0" + number;
        };

        const sd = monthDayFormat(startDate[2]) + ". " + monthDayFormat(startDate[1]) + ". " + startDate[0] + ".";
        const ed = monthDayFormat(endDate[2]) + ". " + monthDayFormat(endDate[1]) + ". " + endDate[0] + ".";

        return (sd + " - " + ed);
    };


    render() {

        const rooms = this.state.recommendations.map(recommends => {
            return (
                <Recommends
                    key={recommends.id}
                    imageUrl={recommends.imageUrl}
                    hotelName ={recommends.hotelName}
                    pricePerNight = {recommends.pricePerNight}
                    roomId = {recommends.id}

                />
            );
        });

        return (

            <div className="container">
                <h2>My Reservations</h2>
            {this.state.myReservations.map(reservation =>
                <div className="reservation-details">
                    <div className="card">
                    <h5><Link className="card-title" to={"/hotels/" + reservation.hotelId}>{reservation.hotelName}</Link></h5>
                    <p><Link className="card-title" to={"/rooms/" + reservation.roomId}>{reservation.roomName}</Link></p>
                        <p>{this.reservedDate(reservation.startDate, reservation.endDate)}</p>
                        <p>{this.buttons(reservation)}
                    {reservation.status === "Arrival" ?
                        <Link to={"ratings/ratingform/"+ reservation.hotelId } className="btn btn-sm btn-primary">Write rating</Link>
                        : ""}</p></div>
                </div>
            )}
                <ReservationForm reservationFormData={this.state.reservationFormData}
                                 inputChangeHandler={this.inputChangeHandler}
                                 reservationSubmit={this.reservationSubmit}
                                 validationHandler={this.validationHandler}/>


                <h2>Rooms suggestions for you </h2>
                <div className="carousel-item active">
                    <div>
                        <div className="row">
                            {rooms}
                        </div>
                    </div>
            </div>
            </div>

        )
    }
}

export default MyReservations;


// WEBPACK FOOTER //
// ./src/containers/MyReservations/MyReservations.jsx